import Vue from 'vue'
const auth = require('./server.js');

const authorize = new Vue({
  data: function() {
    return {
      via_token: this.via_local().get(),
      via_user: this.via_me().get(),
      refreshTimeout: false,
      me: {}
    }
  },
  computed: {
    refreshMarge: function(){
      return 6000 * 10 // === {1 minute in miliseconds} * {minutes}
    },
    via_loggedin: function() {
      var local = this.via_token

      if (local) {
        if (!this.via_local().isValid(local)) {
          // this.via_local().remove()
          return false;
        } else if ((new Date(local.ValidTo).getTime() - this.refreshMarge) > new Date().getTime()) {
          return true;
        } else {
          // this.via_local().remove()
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    via_init: function(){
      var self = this
      return new Promise(function(resolve){
        self.via_isAuthorized().then(function(status){
          if(status){
            if(status === 'valid'){
              self.via_local().refreshTimer();
              resolve(status)
            }else{
              resolve(false)
            }
          }else{
            //self.via_local().remove()
            resolve(false)
          }
        })
      })
    },
    via_isAuthorized: function(noRefresh){
      var _self = this;
      noRefresh = noRefresh || false
      return new Promise(function(resolve){
        var local = _self.via_token
        if (local) {
          if (!_self.via_local().isValid(local)) {
            // _self.via_local().remove()
            resolve(false);
          } else if (new Date(local.ValidTo).getTime() > (new Date().getTime() + _self.refreshMarge)) {
            resolve('valid');
          } else {
            if(!noRefresh && (new Date(local.ValidTo).getTime() - _self.refreshMarge) < new Date().getTime()){
              _self.via_refreshToken().then(function(data){
                if(data.status){
                  resolve('refreshed')
                }else{
                  // console.log('remove1')
                  // _self.via_local().remove()
                  resolve(false)
                }
              })
            }else{
              // console.log('remove2')
              //_self.via_local().remove()
              resolve(false);
            }
          }
        } else {
          resolve(false);
        }
      })
    },
    via_authRoute: function (to, from) {
      var _self = this;

      return new Promise(function (resolve) {
        var requiresAuth = false;
        for(var i = 0; i < to.matched.length; i ++){
          if(to.matched[i].meta.requiresAuth){
            requiresAuth = true;
            break;
          }
        }
        if (requiresAuth) {
          if (!_self.via_loggedin) {
            var local = _self.via_token;
            if (_self.via_local().isValid(local)) {
              _self.via_refreshToken(local).then(function (data) {
                resolve(data.status);
              })
            } else {
              resolve(false);
            }
          } else {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      }).then(function (authenticated) {
        var path = false;
        if (authenticated && to.name === 'login' && _self.via_loggedin)
          path = '/'

        return {
          authenticated: authenticated,
          path: path,
        }
      })
    },
    via_getToken: function(){
      var _self = this;
      var local = _self.via_token
      if(local){
        if(_self.via_local().isValid(local)){
          return _self.via_jwtDecode(local.Token)
        }else{
          return false
        }
      } else{
        return false
      }
    },
    via_jwtDecode: function (token) {
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));

      return JSON.parse(jsonPayload);
    },
    via_hasRole: function(role){
      var _self = this;
      role = role || false;
      if(!role)
        return role;
      
      var local = _self.via_token
      if(local){
        var roles = _self.via_jwtDecode(local.Token).role
        if(roles.indexOf(role) > -1){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
    via_login: function (username, password) {
      var _self = this;

      return new Promise(function (resolve) {
        if (username && username != '' && password && password != ''){
          auth.login(resolve, username, password)
        } else {
          resolve({
            status: false,
            data: "Username and password are required"
          })
        }
      }).then(function (serv_resp1) {
        return new Promise(function (resolve) {
          if (serv_resp1.status === 200) {
            auth.getMe(resolve, serv_resp1.data);
          }else{
            resolve([serv_resp1])
          }
        })
      }).then(function (response) {
        var serv_resp2 = response[0] ? response[0] : false
        var logindata = response[1] ? response[1] : false
        if (serv_resp2.status === 200) {
          //success
          _self.via_me().set(serv_resp2.data);
          _self.via_local().set(logindata);
          _self.via_local().refreshTimer();

          return {
            status: true,
            data: logindata,
          }
        } else {
          //error
          // _self.via_local().remove();
          return {
            status: serv_resp2.status,
            data: serv_resp2.response,
          }
        }
      })
    },
    via_reset: function (email) {
      var _self = this;

      return new Promise(function (resolve) {
        if (email && email != '')
          auth.reset(resolve, email)
        else
          resolve({
            status: false,
            data: "Email is required"
          })
      }).then(function (serv_resp) {
        if (serv_resp.status === 200) {
          //success
          return {
            status: true,
            data: serv_resp.data,
          }
        } else {
          //error
          return {
            status: serv_resp.status,
            data: serv_resp.data,
          }
        }
      })
    },
    via_logout: function () {
      var _self = this;
      return new Promise(function(resolve){
        auth.logout(resolve)
        _self.via_local().remove()
      })
    },
    via_refreshToken: function (local) {
      var _self = this;
      local = local || _self.via_local().get()
      return new Promise(function (resolve) {
        if (_self.via_local().isValid(local)) {
          auth.refreshToken(resolve, local.RefreshToken)
        } else {
          resolve(false);
        }
      }).then(function (serv_resp) {
        if (serv_resp.status === 200) {
          //success
          _self.via_local().set(serv_resp.data)
          _self.via_local().refreshTimer();
          return {
            status: true,
            data: serv_resp.data,
          }
        } else {
          //error
          _self.via_local().remove()
          return {
            status: false,
            data: serv_resp.error,
          }
        }
      })
    },
    via_local: function () {
      var _this = this;
      return {
        get: function () {
          try {
            return JSON.parse(_this.via_cookie().get('.Token') || '{}')
          } catch(e) {
            return {}
          }
          // return JSON.parse(_this.via_cookie().get('.VIA-AUTH') || '{}')
        },
        set: function (data) {
          _this.via_token = data
        },
        store: function (data) {
          _this.via_cookie().set('.Token', JSON.stringify(data))
        },
        remove: function () {
          _this.via_token = {}
        },
        isValid: function (obj) {
          obj = obj || this.get()
          return !!(obj && typeof obj === 'object' && obj !== null && 'Token' in obj && 'RefreshToken' in obj && 'ValidTo' in obj)
        },
        refreshTimer: function () {
          //{difference between validTo and now} - {marge}
          var milisec = (new Date(_this.via_token.ValidTo).getTime() - new Date().getTime()) - _this.refreshMarge;
          clearTimeout(_this.refreshTimeout)
          _this.refreshTimeout = setTimeout(function () {
            _this.via_refreshToken(_this.via_token).then(function (data) {
              if (!data.status)
                location.reload();
            })
          }, milisec)
          // var minutes = Math.floor(milisec / 60000);
          console.log('Time to refresh token: ' + _this.millisToMinutesAndSeconds(milisec))
        }
      }
    },
    millisToMinutesAndSeconds: function(millis) {
      var minutes = Math.floor(millis / 60000);
      var seconds = ((millis % 60000) / 1000).toFixed(0);
      return minutes + ":" + (seconds < 10 ? '0' : '') + seconds;
    },
    via_getMe: function(force){
      var _self = this
      var local = _self.via_local().get()
      force = force || false;
      return new Promise(function (resolve) {
        if ((!force && Object.keys(_self.me).length > 0) || !_self.via_local().isValid()) {
          resolve();
        } else {
          auth.getMe(resolve, local);
        }
      }).then(function(serv_resp){
        if (serv_resp && serv_resp.length > 0 && serv_resp[0].status === 200) {
          _self.me = serv_resp[0].data
        }
        return _self.me
      })
    },
    via_me: function () {
      var _this = this;
      return {
        get: function () {
          // return JSON.parse(sessionStorage.getItem('.ME') || '{}')
          return JSON.parse(_this.via_cookie().get('user') || '{}')
        },
        set: function (data) {
          _this.via_user = data
        },
        store: function (data) {
          // sessionStorage.setItem('.ME', JSON.stringify(data));
          _this.via_cookie().set('user', JSON.stringify({
            Fullname: data.Profile.Fullname,
            Avatar: data.Profile.Avatar,
            Username: data.Username
          }))
        },
        remove: function () {
          _this.via_user = {}
        },
      }
    },
    via_cookie: function () {
      var _this = this;
      return {
        set: function (name, value, days) {
          // var expires = "";
          // if (days) {
          //   var date = new Date();
          //   date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          //   expires = "; expires=" + date.toUTCString();
          // }
          // document.cookie = name + "=" + (value || "") + expires + "; secure; domain=" + window.location.hostname + "; path=/";//.replace('www.', '.')
          window.sessionStorage.setItem(name, value)
        },
        get: function (name) {
          // var nameEQ = name + "=";
          // var ca = document.cookie.split(';');
          // for (var i = 0; i < ca.length; i++) {
          //   var c = ca[i];
          //   while (c.charAt(0) == ' ') c = c.substring(1, c.length);
          //   if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length).replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
          // }
          // return false;
          const session = window.sessionStorage.getItem(name);
          return session || false
        },
        remove: function (name) {
          document.cookie = name + '=; Max-Age=-99999999;';
        }
      }
    }
  },
  watch: {
    via_token: {
      handler: function (val) {
        this.via_local().store(val)
      },
      deep: true
    },
    via_user: {
      handler: function (val) {
        this.via_me().store(val)
      },
      deep: true
    }
  }
})

export default authorize;